import React from 'react';
import { Card, Dropdown, Table } from '@themesberg/react-bootstrap';
import { storeTypes, studentSingleReducerTypes } from 'types';
import { useSelector } from 'react-redux';
import { convertDate, simpleEncrypt } from '../../utils/helpers';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';

export const StudentEventTables = () => {
    const history = useHistory();

    const { studentDataSingleState } = useSelector((state: storeTypes.IStore) => state);
    const { data, isLoading } = studentDataSingleState;
    const eventData = data?.register_events || [];

    // eslint-disable-next-line no-shadow
    const TableRow = ({ data, index }: { data: studentSingleReducerTypes.IRegisterEvents; index: number }) => {
        return (
            <tr>
                <td>
                    <span className="fw-normal">{index + 1}</span>
                </td>
                <td>
                    <span className="fw-normal">{data?.event?.title}</span>
                </td>
                <td>
                    <span className="fw-normal">{convertDate(data?.created_at, 'DD-MM-YYYY hh:mm A')}</span>
                </td>
                <td>
                    <Dropdown.Item onClick={() => history.push(`/events/${simpleEncrypt(data?.event_id)}/view`)}>
                        <FontAwesomeIcon icon={faEye} className="me-2" />
                    </Dropdown.Item>
                </td>
            </tr>
        );
    };

    return (
        <Card border="light" className="table-wrapper table-responsive shadow-sm">
            <Card.Body className="pt-0">
                <Table hover className="user-table align-items-center">
                    <thead>
                        <tr>
                            <th className="border-bottom">#</th>
                            <th className="border-bottom">Title</th>
                            <th className="border-bottom">Register Date</th>
                            <th className="border-bottom">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading && (
                            <tr>
                                <td align="center" colSpan={7}>
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </td>
                            </tr>
                        )}

                        {!isLoading && !eventData.length && (
                            <tr>
                                <td align="center" colSpan={6}>
                                    <span className="fw-normal">Not yet registered</span>
                                </td>
                            </tr>
                        )}

                        {!isLoading &&
                            eventData.map((event: studentSingleReducerTypes.IRegisterEvents, index: number) => {
                                return <TableRow data={event} index={index} key={`transaction-${event.id}`} />;
                            })}
                    </tbody>
                </Table>
            </Card.Body>
        </Card>
    );
};
